/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Finding } from './Finding';
import { FindingFromJSON, FindingFromJSONTyped, FindingToJSON } from './Finding';

/**
 *
 * @export
 * @interface PaginatedFindingList
 */
export interface PaginatedFindingList {
  /**
   *
   * @type {number}
   * @memberof PaginatedFindingList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedFindingList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedFindingList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Finding>}
   * @memberof PaginatedFindingList
   */
  results: Array<Finding>;
}

/**
 * Check if a given object implements the PaginatedFindingList interface.
 */
export function instanceOfPaginatedFindingList(value: object): value is PaginatedFindingList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedFindingListFromJSON(json: any): PaginatedFindingList {
  return PaginatedFindingListFromJSONTyped(json, false);
}

export function PaginatedFindingListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedFindingList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(FindingFromJSON),
  };
}

export function PaginatedFindingListToJSON(value?: PaginatedFindingList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(FindingToJSON),
  };
}
